<template>
  <div class="page1 full-page" :class="$t('full_own_box')">
    <!--地图挂载-->
    <div class="map">
      <!--  百度GL <div style="width:85%;margin:0 auto;height:100%;" ref="echarts1"></div> -->
      <!--   <video class="video" ref="video" muted loop autoplay src="../../assets/mp4/fullpage.mp4"></video> -->
    </div>
    <div class="data-box">
      <h3>
        <!-- <i :class="[ 'wow', 'fadeInDown',zhoren==='zh'?'icon-title':'icon-title icon-title-eng']"></i> -->
        <template v-if="zhoren==='zh'">
          <span class="wow fadeInDown zh-title">专注验货十七年</span>
          <span class="wow fadeInDown zh-title"></span>
          <span class="wow fadeInDown zh-title">全球<span style="color: #FF5023;">质量管控</span>自助平台</span>
        </template>
        <template v-else>
          <span class="wow fadeInDown en-title">
            {{$t('page_o_o')}}<br />
            {{$t('page_o_t')}}
            </span>
        </template>
      </h3>
      <h4 stylw="display: felx;flex-direction:column;" class="wow fadeInUp" data-wow-duration="1s">
        <!-- <i :class="['icon-ljssyh',zhoren==='en'?'eng' :'']"></i> -->
        <template v-if="zhoren==='zh'">
          <span class="icon-ljssyh">累计实施验货(票)</span>
        </template>
        <template v-else>
          <span class="icon-ljssyh en" >{{$t('page_o_s')}}</span>
        </template>
        <div class="number-pic">
          {{Count}}
          <!-- <i :class="['blue-bg-icon','blue-bg-'+item]" v-for="(item,index) in Count" :key="index">{{item}}</i> -->
        </div>
        <!-- <div class="inline piao">{{$t('page1piao')}}</div> -->
      </h4>
      <div class="btn-group wow fadeInDown" data-wow-duration="1.3s">
        <!--<router-link v-if="Number(userInfo.role) !==2" tag="a" target="_blank" to="/index/wantOrder" class="hanle hvr-float-shadow">
          我要验货
          <i class="handle"></i>
        </router-link>-->
        <a
          :class="$t('iba_bnt')"
          href="javascript:void(1)"
          @click="goDetails"
          style="cursor:pointer"
          class="hanle hvr-float-shadow"
        >{{$t('page1btn1')}}</a>
        <!-- <router-link tag="a" to="/index/search" class="hvr-float-shadow">{{$t('page1btn2')}}</router-link> -->
        <!-- <span class="hvr-float-shadow" @click="goSearch">{{$t('page1btn2')}}</span> -->
      </div>
      <div class="tab-list">
        <a
          class="tab-item wow fadeInUp"
          data-wow-duration="1.5s"
          target="_blank"
          href="/index/ourServer?index=0"
        >
          <div class="firfox-bar">
            <div class="default-text">
              <i class="icon-cyjy"></i>

              <p>{{$t('page1item1')}}</p>
            </div>
            <div class="hover-bar">
              <div class="hover-bar-center">
                <h4>{{$t('page1item1')}}</h4>
                <p v-show="zhoren==='zh'">准备出货前，根据国际抽样标准进行随机抽样检验</p>
              </div>
            </div>
          </div>
        </a>
        <a
          class="tab-item wow fadeInUp"
          data-wow-duration="1s"
          target="_blank"
          href="/index/ourServer?index=1"
        >
          <div class="firfox-bar">
            <div class="default-text">
              <i class="icon-qsjy"></i>
              <p>{{$t('page1item2')}}</p>
            </div>
            <div class="hover-bar">
              <div class="hover-bar-center">
                <h4>{{$t('page1item2')}}</h4>
                <p v-show="zhoren==='zh'">我们根据客户的要求，对每一件产品进行检验</p>
              </div>
            </div>
          </div>
        </a>
        <a
          class="tab-item wow fadeInUp"
          data-wow-duration="1.8s"
          target="_blank"
          href="/index/ourServer?index=2"
        >
          <div class="firfox-bar">
            <div class="default-text">
              <i class="icon-zxjy"></i>
              <p>{{$t('page1item3')}}</p>
            </div>
            <div class="hover-bar">
              <div class="hover-bar-center">
                <h4>{{$t('page1item3')}}</h4>
                <p v-show="zhoren==='zh'">监督产品的整个生产过程是否同您的规格要求保持一致，降低工厂延迟交货的风险</p>
              </div>
            </div>
          </div>
        </a>
        <a
          class="tab-item wow fadeInUp"
          data-wow-duration="2.4s"
          target="_blank"
          href="/index/ourServer?index=3"
        >
          <div class="firfox-bar">
            <div class="default-text">
              <i class="icon-gcsh"></i>
              <p>{{$t('page1item4')}}</p>
            </div>
            <div class="hover-bar">
              <div class="hover-bar-center">
                <h4>{{$t('page1item4')}}</h4>
                <p v-show="zhoren==='zh'">通过现场采集被审核单位的信息，对该单位的生产经营能力及质量管理水平提供容观的评估</p>
              </div>
            </div>
          </div>
        </a>
        <a
          class="tab-item wow fadeInUp"
          data-wow-duration="3.2s"
          target="_blank"
          href="/index/ourServer?index=4"
        >
          <div class="firfox-bar">
            <div class="default-text">
              <i class="icon-hgjz"></i>
              <p>{{$t('page1item5')}}</p>
            </div>
            <div class="hover-bar">
              <div class="hover-bar-center">
                <h4>{{$t('page1item5')}}</h4>
                <p v-show="zhoren==='zh'">对指定货物进行装柜监督确保交付的产品及数量是正确的。</p>
              </div>
            </div>
          </div>
        </a>
        <a
          class="tab-item wow fadeInUp"
          data-wow-duration="4s"
          target="_blank"
          href="/index/ourServer?index=5"
        >
          <div class="firfox-bar">
            <div class="default-text">
              <i class="icon-yhjz"></i>
              <p>{{$t('page1item6')}}</p>
            </div>
            <div class="hover-bar">
              <div class="hover-bar-center">
                <h4>{{$t('page1item6')}}</h4>
                <p v-show="zhoren==='zh'">对指定货物进行装柜监督，并添加验货服务，确保交付的产品及数量是符合要求的</p>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import echarts from "echarts";
// require("@/assets/js/world.js");
// import "echarts-gl";
// import mapDot from "./map.json";
import { orderCount, bigData } from "@/api/webIndex";
export default {
  name: "page1",
  data() {
    return {
      test: "",
      Count: "0",
      leftDataIsLoading: false,
      timer1: null,
      mapLineArr: [],
      page1Map: null,
      timer2: null,
      timer3: null,
      timer4: null,
      zhoren: localStorage.getItem("locale") || "zh",
      userInfo: {
        role: 2, //默认身份不能打开详情
      },
      lastSum: 0,
    };
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo
      ? userInfo
      : {
          role: 2, //默认身份不能打开详情
        };
    //模拟数据
    /*     let that = this;
    let random = parseInt(Math.random() * 200);
    if (random.toString().length < 7) {
      this.Count = (Number(random) + 10000000).toString().substring(1);
    } */
  },

  methods: {
    goSearch() {
      const url = this.$router.resolve("/index/search");
      window.open(url.href);
    },
    goDetails() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
	  let url = this.$router.resolve("/index/wantOrder");
	  if(!userInfo){
		  url = this.$router.resolve("/index/login");
	  } 
	  location.href=url.href;
	  return;
      if (userInfo && Number(userInfo.role) === 2) {
        this.$message({
          message: this.$t("page2yhybnxd"),
          type: "warning",
        });
        return;
      } else {
        let url = this.$router.resolve("/index/wantOrder");
        window.open(url.href);
      }
    },
    async getleftData() {
       
      if (this.leftDataIsLoading) {
        return;
      }
      this.leftDataIsLoading = true;
      let res = await bigData();
      const { data, code } = res.data;
     console.log(' ',data )
      if (code == 200) {
        this.leftDataIsLoading = false;
        // clearInterval(this.timer1);
        data.orderList.forEach((item, index) => {
          this.mapLineArr.push(item.map);
        });
        /*         this.$nextTick(function() {
          this.createMapLine();
        }); */
      } else {
        this.leftDataIsLoading = false;
      }
    },
    async getorderCount() {
      let res = await orderCount();
      const { data, code } = res.data;
      if (code == 200) {
        let that = this;
        if (data.count > that.lastSum) {
          that.lastSum = data.count;
          setTimeout(function () {
            that.numberAni(data.count);
          }, 1000);
        }
        /* this.Count = data.count;
        if (this.Count.toString().length < 7) {
          //this.Count = (this.Count + 10000000).toString().substring(1);
        } else {
          //this.Count = this.Count.toString();
        } */
      }
    },
    toThousands(num) {
      return num.toString().replace(/\d+/, function(n) {
          return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      });
    },
    //数字切换动画
    numberAni(value) {
      let that = this;
      clearInterval(this.timer3);
      let sum = Number(that.Count) || 0;
      this.timer3 = setInterval(function () {
        let speed = (value - sum) / 2;
        speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
        sum += speed;
        /*     if (sum.toString().length < 7) {
          sum = (sum + 10000000).toString().substring(1);
        } else {
          sum = sum.toString();
        }; */
        if (Number(sum) >= Number(value)) {
          clearInterval(that.timer3);
          if (sum.toString().length < 6) {
            that.Count = that.toThousands((sum + 1000000).toString().substring(1));
          } else {
            that.Count = that.toThousands(sum.toString());
          }
          return;
        }

        if (sum.toString().length < 6) {
          that.Count = that.toThousands((sum + 1000000).toString().substring(1));
        } else {
          that.Count = that.toThousands(sum.toString());
        }
      }, 30);
    },
    //地图飞线展示
    createMapLine() {
      let that = this;
      that.page1Map = echarts.init(this.$refs.echarts1);
      let option = null;
      let routes = mapDot.arr1;
      // let routes = this.mapLineArr

      that.page1Map.setOption({
        geo3D: {
          map: "world",
          shading: "realistic",
          silent: true,
          environment: "#00023a",
          realisticMaterial: {
            roughness: 0.8,
            metalness: 0,
          },
          itemStyle: {
            color: "#0079fa",
            opacity: 0.5,
            borderWidth: 0,
            borderColor: "#73d2f2",
          },
          postEffect: {
            enable: false,
          },
          groundPlane: {
            show: false,
          },
          light: {
            main: {
              intensity: 1,
              alpha: 30,
            },
            ambient: {
              intensity: 0,
            },
          },
          viewControl: {
            distance: 70,
            alpha: 89,
            panMouseButton: "left",
            rotateMouseButton: "right",
          },
          regionHeight: 0.5,
        },
        series: [
          {
            type: "lines3D",
            coordinateSystem: "geo3D",
            effect: {
              show: true,
              trailWidth: 0.8,
              trailOpacity: 0.8,
              trailLength: 0.2,
              constantSpeed: 2,
            },

            blendMode: "lighter",

            lineStyle: {
              width: 0.5,
              opacity: 0,
              color: "#4694D6",
            },

            polyline: false,
            data: routes,
          },
        ],
      });

      window.addEventListener("keydown", function () {
        that.page1Map.dispatchAction({
          type: "lines3DToggleEffect",
          seriesIndex: 0,
        });
      });

      window.addEventListener("resize", function () {
        that.page1Map.resize();
      });
      if (option && typeof option === "object") {
        that.page1Map.setOption(option, true);
      }
    },
    //是否是手机打开
    isDevicePhone() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          sUserAgent
        )
      ) {
        //跳转移动端页面
        this.$refs.video.remove();
      } else {
        //跳转pc端页面
      }
    },
    //开启webwoker
    openWebWoker() {
      var w = "";
      var that = this;
      if (typeof Worker !== "undefined") {
        if (!w) {
          w = new Worker("../../../public/webworker.js");
        }
        w.onmessage = function (event) {
          console.log(event);
          // that.getorderCount();
        };
      } else {
        alert("当前浏览器不支持服务器推送，页面中的数据将无法实时推送");
      }
    },
  },
  async mounted() {
    if (window.ActiveXObject || "ActiveXObject" in window) {
    } else {
      // this.createMapLine(); //浏览器大于ie8
    }

    let this_ = this;
    clearInterval(this.timer4);
    this.timer4 = setInterval(function () {
      this_.getorderCount();
    }, 5000);

    //await this.getleftData();
    await this_.getorderCount();
  },
  computed: {},
  destroyed() {
    try {
      if(this.page1Map) this.page1Map.dispose();
      clearInterval(this.timer4);
    } catch (e) {}
  },
  watch: {
    "$route.hash"() {
      try {
        if (this.$route.hash === "#page1") {
          if (window.ActiveXObject || "ActiveXObject" in window) {
          } else {
            // this.createMapLine();
          }
          //this.$refs.video.play();
        } else {
          //this.$refs.video.pause();
          // this.page1Map.dispose();
        }
      } catch (e) {}
    },
  },
};
</script>

<style scoped lang="scss">
$width: 8.21px;
/* 数量背景图*/
.blue-bg-icon {
  height: 90px * 0.8 / $width * 1vh;
  width: 74px * 0.8 / $width * 1vh;
  display: inline-block;
  background-size: cover;
  background-position: center center;
}

.blue-bg-0 {
  background-image: url("../../assets/fullpageImage/blue-bg-0.png");
}
.blue-bg-1 {
  background-image: url("../../assets/fullpageImage/blue-bg-1.png");
}
.blue-bg-2 {
  background-image: url("../../assets/fullpageImage/blue-bg-2.png");
}
.blue-bg-3 {
  background-image: url("../../assets/fullpageImage/blue-bg-3.png");
}
.blue-bg-4 {
  background-image: url("../../assets/fullpageImage/blue-bg-4.png");
}
.blue-bg-5 {
  background-image: url("../../assets/fullpageImage/blue-bg-5.png");
}
.blue-bg-6 {
  background-image: url("../../assets/fullpageImage/blue-bg-6.png");
}

.blue-bg-7 {
  background-image: url("../../assets/fullpageImage/blue-bg-7.png");
}

.blue-bg-8 {
  background-image: url("../../assets/fullpageImage/blue-bg-8.png");
}
.blue-bg-9 {
  background-image: url("../../assets/fullpageImage/blue-bg-9.png");
}

.inline {
  display: inline-block;
  vertical-align: middle;
}
.page1 {
  width: 100%;
  height: 100%;
  position: relative;
  .map {
    width: 100%;
    height: 100vh;
    // background-color: #00023a;
    //background-image: url("../../assets/fullpageImage/home-top-bg.png");
	background-image: url("../../assets/fullpageImage/home-top-bg.jpg");
    background-repeat: no-repeat;
    background-position: center center;
	background-size:100%;
    // background-size: 1300px auto; 
    .video {
      display: block;
      width: 100%;
      object-fit: cover;
      border: none;
      margin: 0 auto;
      max-height: 100%;
    }
  }
  .data-box {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    padding: 136px / $width * 1vh 0 20px / $width * 1vh;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0);
    h3 {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 23px;
      .zh-title{
        // width: 100%;
        // height: 100px / $width * 1vh;
        color: #fff;
        font-size: 30px;
        line-height: 30px;
        letter-spacing: 8px;
        text-shadow: 0 0 50px #192bff;
        display: inline-block;
      }
      .zh-title:nth-child(2) {
        width: 2px;
        height: 30px;
        margin: 0 15px 0 10px;
        background-color: #fff;
      }
      .en-title{
        width: 100%;
        height: 100px / $width * 1vh;
        color: #fff;
        font-size: 62px / $width * 0.8vh;
        line-height: 90px / $width * 0.8vh;
        text-shadow: 0 0 50px #192bff;
        display: inline-block;
      }
      // .icon-title {
      //   display: inline-block;
      //   width: 100%;
      //   height: 100px / $width * 1vh;
      //   background: url("../../assets/fullpageImage/page1_title1.png") no-repeat;
      //   background-size: auto 100px / $width * 1vh;
      //   background-position: center center;
      // }
      // .icon-title-eng {
      //   height: 159px / $width * 1vh;
      //   background: url("../../assets/fullpageImage/page1_title1_eng.png")
      //     no-repeat;
      //   background-size: auto 159px / $width * 1vh;
      //   background-position: center center;
      // }
    }
    h4 {
      margin-top: 125px / $width * 1vh;
      text-align: center;
      font-size: 0;
      width: 50%;
      margin: 47px auto;
      .icon-ljssyh {
        font-size: 24px;
        display: inline-block;
        // width: 239px / $width * 1vh;
        color: #fff;
        font-weight: 500;
        // text-shadow: 0 0 20px #192bff;
        // background: url("../../assets/fullpageImage/page1_ljssyh.png") no-repeat;
        // background-size: 100% auto;
        // vertical-align: middle;
        // background-position: center;
        &.en {
          width: 320px / $width * 1vh;
          // background-image: url("../../assets/fullpageImage/page1_ljssyh_eng.png");
        }
      }
      .number-pic {
        color: #ffffff;
        text-align: center;
        font-size: 72px;
        font-family: Avenir;
        font-weight: 900;

        // & > img {
        //   height: 90px;
        //   display: inline-block;
        // }
      }
      // .piao {
      //   font-size: 17px / $width * 1vh;
      //   color: #ffffff;
      //   margin-left: 8px;
      // }
    }
    .btn-group {
      text-align: center;
      margin-top: 40px / $width * 1vh;
      & > a {
        display: inline-block;
        /*  background: url("../../assets/fullpageImage/btn-bg.png") no-repeat;
        background-size: 100% 100%; */
        /*  width: 250px / $width * 1vh; */
        width: 260px;
        height: 70px;
        background: #FF5023;
        border-radius: 10px;
        font-size: 30px;
        color: #FFFFFF;
        text-align: center;
        line-height: 70px;
        font-family: FZLanTingHei-DB-GBK;
        // padding: 0 30px / $width * 1vh;
        // height: 72px / $width * 1vh;
        // vertical-align: middle;
        // font-size: 32px / $width * 1vh;
        // color: #f7fbfb;
        // text-decoration: none;
        // line-height: (72px - 8px) / $width * 1vh;
        // position: relative;
        // border: 4px solid #fff;
        // border-radius: 36px / $width * 1vh;
        // &:not(:last-child) {
        //   margin-right: 25px / $width * 1vh;
        // }
        /* & > .handle {
          display: block;
          width: 61px;
          height: 49px;
          background: url("../../assets/fullpageImage/page1_handle.png")
            no-repeat;
          background-size: 100% auto;
          background-position: center center;
          position: absolute;
          right: 0;
          bottom: -5px / $width * 1vh;
        } */
      }
    }
    .tab-list {
      display: flex;
      align-items: center;
      justify-content: stretch;
      width: 1200px;
      margin: 100px / $width * 1vh auto 0;
      overflow: hidden;
      .tab-item {
        flex: 1;
        /* background: url("../../assets/fullpageImage/boli-bg.png") no-repeat;
        background-position: center center; */
        background-color: rgba(255,255,255,0.15);
        height: 142px / $width * 1vh;
        position: relative;
        overflow: hidden;
        & > .firfox-bar {
          display: table;
          width: 100%;
          height: 100%;
        }
        .default-text {
          display: table-cell;
          vertical-align: middle;
          word-break: break-word;
          p {
            text-align: center;
            word-break: break-word;
            overflow: hidden;
            text-overflow: ellipsis;
            // display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        &:hover .hover-bar {
          top: 0;
        }
        &:hover .default-text > i,
        &:hover .default-text > p {
          display: none;
        }
        .hover-bar {
          position: absolute;
          top: 100%;
          left: 0;
          z-index: 2;
          background-color: rgba(0, 0, 0, 0.5);
          transition: all 0.5s;
          cursor: pointer;
          text-align: center;
          height: 101%;
          width: 101%;
          padding: 10px;
          box-sizing: border-box;
          display: table;
          .hover-bar-center {
            display: table-cell;
            vertical-align: middle;
            word-break: break-word;
          }
          h4 {
            font-size: 15px;
            line-height: 1.3;
            font-weight: 500;
            color: #fff;
            margin-bottom: 5px;
            margin-top: 0;
            word-break: break-word;
          }
          p {
            font-size: 14px;
            line-height: 1.2;
            color: #fff;
            margin-top: 0;
          }
        }
        p {
          margin-top: 24px / $width * 1vh;
          color: #fff;
          font-size: 16px / $width * 1vh;
        }
        i {
          width: 45px / $width * 1vh;
          height: 45px / $width * 1vh;
          display: block;
          margin: 0 auto 20px / $width * 1vh;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: auto 43px / $width * 1vh;
          transition: all 0.5s;
        }
        &:not(:last-child) {
          margin-right: 14px / $width * 1vh;
        }
        .icon-cyjy {
          background-image: url("../../assets/fullpageImage/FRI_ch.png");
        }
        .icon-qsjy {
          background-image: url("../../assets/fullpageImage/FUI_ch.png");
        }
        .icon-zxjy {
          background-image: url("../../assets/fullpageImage/DPI_ch.png");
        }
        .icon-gcsh {
          background-image: url("../../assets/fullpageImage/FAT.png");
        }
        .icon-hgjz {
          background-image: url("../../assets/fullpageImage/CLS.png");
        }
        .icon-yhjz {
          background-image: url("../../assets/fullpageImage/FRI_CLS_ch.png");
        }
      }
    }
  }
}
@media screen and (max-width: 720px) {
  .page1 {
    .map {
      background-size: auto 50%; 
    }
    .data-box {
      h3 {
        text-align: center;
        .zh-title{
          font-size: 32px / $width * 0.8vh;
          line-height: 50px / $width * 1vh;
          letter-spacing: 0px;
          text-shadow: 0 0 30px #192bff;
        }
        .zh-title:nth-child(1) {
          border-right: 2px solid #fff;
        }
        .en-title{
          font-size: 32px / $width * 0.8vh;
          line-height: 40px / $width * 1vh;
          text-shadow: 0 0 30px #192bff;
        }
      }
      h4 {
        margin-top: 85px / $width * 1vh;
        .icon-ljssyh {
          display: inline-block;
          width: 239px / $width * 1vh;
          font-size: 32px / $width * 0.8vh;
          text-shadow: 0 0 10px #192bff;
          margin-bottom: 20px;
          &.en {
            width: 320px / $width * 1vh;
          }
        }
        .number-pic {
          & > img {
            height: 90px;
            display: inline-block;
          }
        }
        .piao {
          font-size: 24px / $width * 1vh;
        }
      }
      .tab-list {
        width: 100%;
      }
    }
  }
}
.idex_bnt{
  width:340px!important;
}
.idex_bnt_i{
  width:400px!important;
}
.idex_bnt_p{
  width:560px!important;
}
.ru_ru_box .en-title{
  font-size:40px!important;
}
.ru_ru_box .en,.pt_pt_box .en{
  width: 92.97686vh!important;
}
.es_la_box .en{
  width: 102.97686vh!important;
}
</style>